import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "wrap",
		padding: theme.spacing(1.5, 0, 0.5),
		marginBottom: theme.spacing(0.5),
		gap: theme.spacing(2),
		minHeight: 68,
		[theme.breakpoints.down("sm")]: {
			alignItems: "flex-start",
			gap: theme.spacing(1.25),
			minHeight: "auto",
		},
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
